import moment from 'moment'

const getCalcOptions = (key, dayValue) => {
  const ops = key.split('&')
  let track
  let offset = 1
  const dateOffset = (ops[1] && Number.parseInt(ops[1], 10)) || 0
  let type = ops[0]
  switch (dateOffset) {
    case -1: track = 'next'
      break
    case 0:
    case 1:
    default:
      track = 'last'
      offset = dateOffset
  }
  if (type === 'fromDay') {
    type = 'day'
    offset = Number.parseInt(dayValue, 10) || 0
  } else {
    type = (ops[0].split('_'))[1] || 'day'
  }
  return {
    type,
    track,
    offset
  }
}

const fixedDateRange = (key, dayValue) => {
  const { offset, type, track } = getCalcOptions(key, dayValue)
  let weekType = type
  if (weekType === 'week') {
    weekType = 'isoWeek'
  }
  const today = moment()
  let end
  let start
  if (key !== 'fromDay') {
    if (track === 'next') {
      start = today.clone().add(offset, type).startOf(weekType)
      end = start.clone().endOf(weekType)
    } else {
      end = today.clone().subtract(offset, type).endOf(weekType)
      start = end.clone().startOf(weekType)
    }
  } else {
    start = today.clone().subtract(offset, type).startOf(weekType)
    end = today.clone().subtract(offset === 0 ? 0 : 1, type).endOf(weekType)
  }
  return [start, end]
}

const fixedDoubleDate = (key) => {
  const opts = key.split('_')
  const startString = opts[2]
  const endString = opts[3]
  return () => {
    const end = moment(endString)
    const start = moment(startString)
    return [start, end]
  }
}

const elasticityDateRange = (key) => {
  const { offset, type } = getCalcOptions(key)
  return (include = false) => {
    const today = moment()
    const end = include ? today : today.subtract(1, 'day').endOf('day')
    const start = end.clone().subtract(offset, type).startOf('day').add(1, 'day')
    return [start, end]
  }
}
const formatDate = (date) => {
  if (typeof date !== 'string') return []
  const ops = date.split('-')
  if (ops[2]) {
    return [moment(date).clone().startOf('day'),  moment(date).clone().endOf('day')]
  } else if (ops[1]) {
    const start = moment(date).clone().startOf('month')
    const end = start.clone().endOf('month')
    return [moment(start, 'YYYY-MM-DD'), moment(end, 'YYYY-MM-DD')]
  } else if (ops[0]) {
    const start = moment(date).clone().startOf('year')
    const end = start.clone().endOf('year')
    return [moment(start, 'YYYY-MM-DD'), moment(end, 'YYYY-MM-DD')]
  } else {
    return []
  }
}
const formatDay = (date, isEnd) => {
  if (isEnd) {
    return moment(date).clone().endOf('day')
  } else {
    return moment(date).clone().startOf('day')
  }
}
/**
 * element contain element
 * @param root
 * @param n
 * @return {boolean}
 */
const contains = (root, n) => {
  if (!root || !n) return false

  let node = n
  while (node) {
    if (node === root) {
      return true
    }
    node = node.parentNode
  }

  return false
}

export {
  fixedDateRange,
  elasticityDateRange,
  fixedDoubleDate,
  contains,
  formatDate,
  formatDay
}
